@if (vm$ | async; as vm) {
  <div class="uw-dialog-header">
    <h1 class="uw-dialog-heading">{{ "common.profile_settings" | translate }}</h1>
    <button #closeBtn [attr.aria-label]="'aria.close' | translate" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="uw-dialog-content">
    <div [formGroup]="form" class="profile-information__form">
      <div class="uw-field profile-information__salutation">
        <label for="salutation" class="uw-label">{{ "common.salutation" | translate }}</label>
        <select id="salutation" formControlName="salutation" class="uw-select">
          <option value=""></option>
          <option value="Dr.">{{'profile_page.dr' | translate}}</option>
          <option value="Miss.">{{'profile_page.miss' | translate}}</option>
          <option value="Mr.">{{'profile_page.mr' | translate}}</option>
          <option value="Mrs.">{{'profile_page.mrs' | translate}}</option>
          <option value="Ms.">{{'profile_page.ms' | translate}}</option>
        </select>
      </div>
      <div  class="required uw-field profile-information__first-name">
        <label for="firstName" class="uw-label">{{ "common.first_name" | translate }}</label>
        <input id="firstName" formControlName="firstName" class="uw-input" type="text">
        <app-field-error-display [displayError]="isFieldValid(form, 'firstName')"
        errorMsg="common.required"></app-field-error-display>
      </div>
      <div  class="required uw-field profile-information__last-name">
        <label for="lastName" class="uw-label">{{ "common.last_name" | translate }}</label>
        <input id="lastName" formControlName="lastName" class="uw-input" type="text">
        <app-field-error-display [displayError]="isFieldValid(form, 'lastName')"
        errorMsg="common.required"></app-field-error-display>
      </div>
      <div class="required uw-field profile-information__personal-email">
        <label for="personalEmail" class="uw-label">{{ "common.personal_email" | translate }}</label>
        <input id="personalEmail" formControlName="personalEmail" class="uw-input" type="text">
        <app-field-error-display [displayError]="isFieldValid(form, 'personalEmail')"
        errorMsg="common.please_enter_a_valid_email_address"></app-field-error-display>
      </div>
      <div  class="required uw-field profile-information__personal-phone-number">
        <label for="personalPhoneNumber" class="uw-label">{{ "common.personal_phone_number" | translate }}</label>
        <input id="personalPhoneNumber" formControlName="personalPhoneNumber" class="uw-input" type="text" mask="(000) 000-0000" placeholder="(xxx) xxx-xxxx">
        <app-field-error-display [displayError]="isFieldValid(form, 'personalPhoneNumber')"
        errorMsg="common.required"></app-field-error-display>
      </div>
      <div  class="required uw-field profile-information__work-email">
        <label for="workEmail" class="uw-label">{{ "common.work_email" | translate }}</label>
        <input id="workEmail" formControlName="workEmail" class="uw-input" type="text">
        <app-field-error-display [displayError]="isFieldValid(form, 'workEmail')"
        errorMsg="common.please_enter_a_valid_email_address"></app-field-error-display>
      </div>
      <div  class="required uw-field profile-information__work-phone-number">
        <label for="workPhoneNumber" class="uw-label">{{ "common.work_phone_number" | translate }}</label>
        <input id="workPhoneNumber" formControlName="workPhoneNumber" class="uw-input" type="text" mask="(000) 000-0000" placeholder="(xxx) xxx-xxxx">
        <app-field-error-display [displayError]="isFieldValid(form, 'workPhoneNumber')"
        errorMsg="common.required"></app-field-error-display>
      </div>
      <div class="uw-field profile-information__work-phone-ext">
        <label for="workPhoneExt" class="uw-label">{{ "common.extension" | translate }}</label>
        <input id="workPhoneExt" maxlength="10" formControlName="workPhoneExt" class="uw-input" type="text"
          [ngClass]="{'invalid-input' : form.get('workPhoneExt')?.errors?.pattern && form.get('workPhoneExt')?.touched}">
          <app-field-error-display [displayError]="isFieldValid(form, 'workPhoneExt')"
          [errorMsg]="'messages.error.extention_must_be_between_1_and_10_digits' | translate"></app-field-error-display>
        </div>
        <div class="uw-field profile-information__language-preference">
          <label for="languagePref" class="uw-label">{{ "common.language_preference" | translate }}</label>
          <select id="languagePref" formControlName="languagePref" class="uw-select">
            <option value="en-CA">{{ "common.english" | translate }}</option>
            <option value="fr-CA">{{ "common.french" | translate }}</option>
          </select>
        </div>
      </div>
    </div>
    <!--Commented out for #1519 Devops-->
    <!-- <div class="uw-dialog-footer" >
    <div class="uw-actions">
      <button class="uw-stroked-button" mat-dialog-close>
        {{ "common.cancel" | translate }}
      </button>
      <button class='uw-default-button' (click)="save(form.value)" [disabled]="form.pristine || !form.valid" >
        {{ "common.save" | translate }}
      </button>
    </div>
  </div> -->
}
